import React from 'react'
import { connect } from 'react-redux'
import { Modal, Form, Input, Button, message } from 'antd';
import * as actionCreators from '../service/ClientLinkCreator'
import intl from 'react-intl-universal';
const FormItem = Form.Item;
class AddChModal extends React.Component {
  constructor() {
    super()
    this.state = {
      name: "",
      url: ""
    }
  }

  handleChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  submitForm = () => {
    if (this.props.categoryList.length === 0) {
      message.warning("please add a category first")
    } else {
      if (this.state.name === "" || this.state.url === "") {
        message.warning("content is required")
      } else if (this.state.name.length > 40) {
        message.warning("there at most 40 characters")
      } else {
        this.props.addChannel(this.state.name, this.state.url, this.props.selectKey, sessionStorage.getItem("userName"), this.props.pageSize, this.props.form)
      }
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 24,
          offset: 0,
        },
      },
    };
    return (
      <div>
        <Modal
          title="Add channel"
          visible={this.props.channelModalVisible}
          onCancel={this.props.handleCancel}
          footer={null}
        >
          <Form onSubmit={this.handleChannelSubmit}>
            <FormItem {...formItemLayout}
              label={intl.get("channel")}
            >
              {getFieldDecorator('channel', {
                rules: [{ required: true, message: "please enter channelName" },
                { max: 40, message: "there at most 40 characters" }],
              })(
                <Input name="name" onChange={(e) => this.handleChangeInput(e)} />
              )}
            </FormItem>
            <FormItem {...formItemLayout}
              label={intl.get("url")}
            >
              {getFieldDecorator('url', {
                rules: [{ required: true, message: "please enter url" }],
              })(
                <Input name="url" onChange={(e) => this.handleChangeInput(e)} />
              )}
            </FormItem>
            <FormItem {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit" onClick={() => this.submitForm()} style={{ marginLeft: 200 }}>{intl.get("submit")}</Button>
            </FormItem>
          </Form>
        </Modal>
      </div>
    )
  }
}
const mapState = (state) => {
  return {
    channelModalVisible: state.clientLink.channelModalVisible,
    categoryList: state.clientLink.categoryList,
    title: state.clientLink.title,
    flag: state.clientLink.flag,
    categoryName: state.clientLink.categoryName,
    categoryid: state.clientLink.categoryid,
    pageSize: state.clientLink.pageSize,
    selectKey: state.clientLink.selectKey
  }
}
const mapDispatch = (dispatch) => {
  return {
    handleCancel() {
      dispatch(actionCreators.hideChannelModal())
    },

    addChannel(name, url, cid, user, pageSize, form) {
      dispatch(actionCreators.addChannel(name, url, cid, user, pageSize, form))
    }
  }
}

const AddChannelModal = Form.create()(AddChModal);
export default connect(mapState, mapDispatch)(AddChannelModal);


// WEBPACK FOOTER //
// ./src/components/AddChModal.js